<template>
  <div>
    <a :uk-tooltip="$t('general.filter_list')" class="btn btn-icon btn-hover btn-circle"
       href="javascript:void(0)">
      <i class="uil-filter"></i>
    </a>
    <div id="filterDropdown" class="large"
         uk-dropdown="pos: bottom-right; mode: click; animation: uk-animation-scale-up">
      <div class="filter-dropdown-container">
        <div class="filter-content">
          <slot></slot>
        </div>

        <div class="uk-flex uk-flex-right mt-3">
          <button class="btn btn-light mr-2" @click="handleReset">
            {{ $t('general.clear_all') }}
          </button>
          <button class="btn btn-default grey" @click="handleFilter">
            <i class="uil-filter"></i>
            {{ $t('general.filter') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FilterDropdownButton',

  mounted() {
    // UIkit dropdown nesnesini sakla
    this.dropdown = UIkit.dropdown('#filterDropdown');
  },

  methods: {
    handleReset() {
      this.$emit('reset');
    },

    handleFilter() {
      let preventClose = false;
      this.$emit('filter', {
        preventClose: () => {
          preventClose = true;
        },
      });

      this.$nextTick(() => {
        if (!preventClose && this.dropdown) {
          this.dropdown.hide();
        }
      });
    }
  }
}
</script>

<style scoped>
.filter-dropdown-container {
  width: 100%;
}

.filter-content {
  margin-bottom: 1rem;
}
</style>

<style>
.multiselect__tag {
  color: white;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: #3e416d;
}

.multiselect__tag-icon {
  background-color: transparent;
  line-height: 2.2;
}

.multiselect__tag-icon:after {
  color: #fff;
}

.multiselect__tag-icon:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.multiselect__input {
  border: unset !important;
}

.multiselect__tags .multiselect__input {
  border: unset !important;
}
</style>